// Login-page design presets. The active preset is a platform-level setting
// (server admin picks it in Platform Branding) read pre-session from
// /api/branding/platform. Kept as a tiny pure module so both the login page and
// the sultan picker share one source of truth — and so the normalization is
// unit-testable without a DOM.

export const LOGIN_DESIGNS = ['centered', 'split', 'immersive', 'image'];
export const DEFAULT_LOGIN_DESIGN = 'centered';

export const LOGIN_IMAGE_PLACEMENTS = ['background', 'side'];
export const DEFAULT_LOGIN_IMAGE_PLACEMENT = 'background';

/** Coerce any stored/garbage value to a known design (unknown → centered). */
export function normalizeLoginDesign(value) {
  return LOGIN_DESIGNS.includes(value) ? value : DEFAULT_LOGIN_DESIGN;
}

/** Coerce any stored value to a known image placement (unknown → background). */
export function normalizeImagePlacement(value) {
  return LOGIN_IMAGE_PLACEMENTS.includes(value) ? value : DEFAULT_LOGIN_IMAGE_PLACEMENT;
}
